import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";

class AdkBannerFeeds extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            feedToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            feeds: [],
            types: [],
            partners: {},
            defaultOffers: {},
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadFeeds();
        this.loadPartners();
        this.loadDefaultOffers();
    }

    componentWillUpdate(nextProps, nextState) {
        const { feeds, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(feeds, sortParam, sortOrder);

            this.setState({ feeds });
        }
    }

    sortReport(feeds, sortParam, sortOrder) {
        feeds.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadPartners() {
        API.AdkBanner.Partners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {})

            this.setState({ partners });
        });
    }

    loadDefaultOffers() {
        API.AdkBanner.DefaultOffers.getMeta()
            .then(defaultOffers => this.setState({ defaultOffers }));
    }

    loadFeeds() {
        this.setState({ isLoading: true });

        API.AdkBanner.Feeds.get().then(feeds => this.setState({ feeds, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, feedToUpdate: null });
    }

    handleFormSubmit(feed) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            feedToUpdate: null
        });

        if(feed.update) {
            const { id } = feed;

            delete feed.id;

            API.AdkBanner.Feeds.update(id, feed).then(() => this.loadFeeds());
        }
        else API.AdkBanner.Feeds.save(feed).then(() => this.loadFeeds());
    }

    handleUpdateBtnClick(feed) {
        this.setState({ isShowForm: true,  feedToUpdate: feed });
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.AdkBanner.Feeds.remove(id).then(() => this.loadFeeds());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.AdkBanner.Feeds.sync().then(() => this.setState({ isLoading: false }));
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                feed={this.state.feedToUpdate}
                types={this.state.types}
                partners={this.state.partners}
                defaultOffers={this.state.defaultOffers}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Banner Feeds"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>

                {this.getForm()}

                <Table feeds={this.state.feeds} partners={this.state.partners} defaultOffers={this.state.defaultOffers} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default AdkBannerFeeds;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerFeeds/index.js